import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { LastTransaction_lastTransaction } from "../../graphql/graphql_transaction/types/LastTransaction";
import { TransactionByCard_transactionByCard } from "../../graphql/graphql_transaction/types/TransactionByCard";
import { ListCategory_listCategory } from "../../graphql/graphql_transaction/types/ListCategory";
import { AllBeneficiary_allBeneficiary_content } from "../../graphql/graphql_transaction_linkcy/beneficiary/types/AllBeneficiary";
import { TransactionInfo } from "../../graphql/graphql_transaction_linkcy/transaction/types/TransactionInfo";
import { AllSepa_allSepa_content } from "../../graphql/graphql_transaction_linkcy/transaction/types/AllSepa";
import { TransactionPnvtInfo } from "../../graphql/graphql_transaction_linkcy/transaction/types/TransactionPnvtInfo";

export interface ISetDetailsTransaction {
  transactionId: string;
  dataDetails: string;
}
export const transactionSlice = createSlice({
  name: "transaction",
  initialState: {
    transactionInformation: {} as TransactionPnvtInfo | null,
    canCreateTransaction: false,
    lastTransaction: [] as (AllSepa_allSepa_content | null)[],
    txInvalidated: [] as (AllSepa_allSepa_content | null)[],
    lastCardTransaction: [] as (AllSepa_allSepa_content | null)[] | null,
    beneficiaries: [] as (AllBeneficiary_allBeneficiary_content | null)[],
    transactions: [] as Array<AllSepa_allSepa_content | null>,
    transactionByCard: [] as Array<AllSepa_allSepa_content | null>,
    categories: [] as (ListCategory_listCategory | null)[],
  },
  reducers: {
    setBeneficiaries: (
      state,
      action: PayloadAction<(AllBeneficiary_allBeneficiary_content | null)[]>,
    ) => {
      state.beneficiaries = action.payload;
    },
    setCanCreateTransaction: (state, action: PayloadAction<boolean>) => {
      state.canCreateTransaction = action.payload;
    },
    setSelectedTransaction: (
      state,
      action: PayloadAction<TransactionPnvtInfo | null>,
    ) => {
      state.transactionInformation = action.payload;
    },
    setLastTransaction: (
      state,
      action: PayloadAction<(AllSepa_allSepa_content | null)[]>,
    ) => {
      state.lastTransaction = action.payload;
    },
    setLastCardTransaction: (
      state,
      action: PayloadAction<(AllSepa_allSepa_content | null)[] | null>,
    ) => {
      state.lastCardTransaction = action.payload;
    },
    setTxInvalidated: (
      state,
      action: PayloadAction<(AllSepa_allSepa_content | null)[]>,
    ) => {
      state.txInvalidated = action.payload;
    },
    setTransactions: (
      state,
      action: PayloadAction<Array<AllSepa_allSepa_content | null>>,
    ) => {
      state.transactions = action.payload;
    },
    setTransactionsByCard: (
      state,
      action: PayloadAction<Array<AllSepa_allSepa_content | null>>,
    ) => {
      state.transactionByCard = action.payload;
    },
    setCategories: (
      state,
      action: PayloadAction<(ListCategory_listCategory | null)[]>,
    ) => {
      state.categories = action.payload;
    },
  },
});

export const {
  setBeneficiaries,
  setCanCreateTransaction,
  setSelectedTransaction,
  setLastTransaction,
  setLastCardTransaction,
  setTxInvalidated,
  setTransactions,
  setTransactionsByCard,
  setCategories,
} = transactionSlice.actions;

export default transactionSlice.reducer;
